import api from "../index";

export const GetAllAccountApi = (params) => api.get(`IBMaster/MyTeamLive-AccountById?${params}`);
export const MT5RequestAcceptRejectApi = (data) => api.post('Admin/MT5LiveAcc-RejectedApproved', data);
export const GetAllMT5ByIdApi = (MT5Id) => api.get(`MTFiveAccount/UserGetSingle-LiveAccount/${MT5Id}`);
export const CloseMT5TradeApi = (data) => api.post('MTFiveAccount/Close-MT5-Trade', data);
export const GetUserLiveDashboardApi = (accountId) => api.get(`MTFiveAccount/User-Live-Dashboard/${accountId}`);
export const GetOpenPositionApi = (accountId) => api.get(`MTFiveAccount/Open-Position/${accountId}`);
export const GetTradeAccountOverviewApi = (loginId) => api.get(`MTFiveAccount/Trade-Account-Overview?LoginId=${loginId}`);
export const GetAccountPerformanceApi = () => api.get('MTFiveAccount/Account-Performance');
export const GetFirstLevelOpenTradeApi = () => api.get('MTFiveAccount/FirstLevel-Open-Trade');